<template>
  <!-- 결제 성공 시 -->
  <section>
    <div class="box_section" style="width: 600px;">
      <img
        style="width: 100px;"
        src="https://static.toss.im/illusts/check-blue-spot-ending-frame.png"
      />
      <h2>결제를 완료했어요</h2>

      <div class="p-grid typography--p" style="margin-top: 50px;">
        <div class="p-grid-col text--left"><b>결제금액</b></div>
        <div class="p-grid-col text--right" id="amount">
          <!-- {{ jsonData.totalAmount }}원 -->
        </div>
      </div>
      <div class="p-grid typography--p" style="margin-top: 10px;">
        <div class="p-grid-col text--left"><b>주문번호</b></div>
        <div class="p-grid-col text--right" id="orderId">
          <!-- {{ jsonData.orderId }} -->
        </div>
      </div>
      <div class="p-grid typography--p" style="margin-top: 10px;">
        <div class="p-grid-col text--left"><b>paymentKey</b></div>
        <div
          class="p-grid-col text--right"
          id="paymentKey"
          style="white-space: initial; width: 250px;"
        >
          <!-- {{ jsonData.paymentKey }} -->
        </div>
      </div>
      <div class="p-grid" style="margin-top: 30px;">
        <button
          class="button p-grid-col5"
          onclick="location.href='https://docs.tosspayments.com/guides/payment/integration';"
        >
          연동 문서
        </button>
        <button
          class="button p-grid-col5"
          onclick="location.href='https://discord.gg/A4fRFXQhRu';"
          style="background-color: #e8f3ff; color: #1b64da;"
        >
          실시간 문의
        </button>
      </div>
    </div>
    <div class="box_section" style="width: 600px; text-align: left;">
      <b>Response Data :</b>
      <div id="response" style="white-space: initial;">
        <!-- <pre>{{ jsonData }}</pre> -->
      </div>
    </div>
  </section>
</template>

<script>
import { TOSS_PAYMENT_CONFIRM } from '@/store/types'
export default {
  data() {
    return {
      requestData: null,
      orderData: null
    }
  },
  async mounted() {
    this.requestData = {
      orderId: this.$route.query.orderId,
      amount: this.$route.query.amount,
      paymentKey: this.$route.query.paymentKey
    }

    this.orderData = JSON.parse(localStorage.getItem('orderData'))
    this.orderData.purchase.orders.procTp = 'PG'
    console.log(this.orderData)
    localStorage.removeItem('orderData')

    const response = await this.$store.dispatch(TOSS_PAYMENT_CONFIRM, {
      requestData: this.requestData,
      orderData: this.orderData
    })
    // console.log(response)
    const orderName = response.data?.orderName
    const price = response.data?.totalAmount
    const payMethod = response.data?.easyPay?.provider || response.data?.method
    await this.$router.push({
      path: '/cart/order_successful',
      query: {
        buyCd: this.orderData.purchase.orders.payment.merchantId,
        items: this.orderData.purchase.orders.payment.applyNum,
        orderName: orderName,
        price: price,
        payMethod: payMethod
      }
    })
  },
  methods: {}
}
</script>
